function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["default"];
var availableDPR = [3, 2, 1];
var vwRegex = /^([0-9]*)vw$/;
var pxRegex = /^([0-9]*)px$/;
var calcRegex = /^calc\((.*)\)$/;

function scaleSizeFromDPR(dpr, maxDPR, value) {
  var _ref;

  var vwMatch = value.match(vwRegex);
  var ratio = maxDPR / dpr;

  if (vwMatch && vwMatch[1]) {
    return Math.ceil(parseInt(vwMatch[1], 10) * ratio) + "vw";
  }

  var pxMatch = value.match(pxRegex);

  if (pxMatch && pxMatch[1]) {
    return Math.ceil(parseInt(pxMatch[1], 10) * ratio) + "px";
  }

  var calcMatch = value.match(calcRegex); // Scale calc value or other things (min, max etc...)

  return "calc((" + ((_ref = calcMatch && calcMatch[1]) != null ? _ref : value) + ") * " + Math.round(ratio * 100) / 100 + ")";
}

function getBreakpointDPRMediaQueries(breakpoint, value, dpr, maxDPR, dpiCompatibility) {
  if (dpiCompatibility === void 0) {
    dpiCompatibility = false;
  }

  var scaledValue = scaleSizeFromDPR(dpr, maxDPR, value);
  return ["(min-resolution: " + dpr + "dppx)", "(-webkit-min-device-pixel-ratio: " + dpr + ")", dpiCompatibility ? "(min-resolution: " + 96 * dpr + "dpi)" : ''].filter(function (mediaQuery) {
    return !!mediaQuery;
  }).map(function (mediaQuery) {
    return "" + mediaQuery + (breakpoint ? " and " + breakpoint + " " : ' ') + scaledValue;
  }).join(', ');
}

function getBreakpointValue(value, _ref2, breakpoint) {
  var maxDPR = _ref2.maxDPR,
      dpiCompatibility = _ref2.dpiCompatibility;
  var breakPointValue = breakpoint ? breakpoint + " " + value : value;

  if (maxDPR) {
    var capedDPRBreakpoints = availableDPR.filter(function (dpr) {
      return dpr > maxDPR;
    }).map(function (dpr) {
      return getBreakpointDPRMediaQueries(breakpoint, value, dpr, maxDPR, dpiCompatibility);
    }).join(', ');
    return capedDPRBreakpoints.length > 0 ? capedDPRBreakpoints + ", " + breakPointValue : breakPointValue;
  } else {
    return breakPointValue;
  }
}

function generateSizes(params, options) {
  if (options === void 0) {
    options = {};
  }

  var receivedDefaultValue = params["default"],
      breakpoints = _objectWithoutPropertiesLoose(params, _excluded);

  var breakpointsValue = Object.keys(breakpoints).map(function (breakpoint) {
    return getBreakpointValue(breakpoints[breakpoint], options, breakpoint);
  }).join(", ");
  var defaultValue = getBreakpointValue(receivedDefaultValue, options);
  return breakpointsValue.length > 0 ? breakpointsValue + ", " + defaultValue : defaultValue;
}

export { generateSizes as default };
//# sourceMappingURL=html-sizes.esm.js.map
